declare global {
  interface Window {
    OneTrust?: {
      ToggleInfoDisplay?: () => void;
    };
  }
}

export const openCookieSettings = (): void => {
  window.OneTrust?.ToggleInfoDisplay?.();
};
